import Link from "next/link";
import {scrollToElement} from "@/utils/scrollToElement";

export const PRICING_NOTES = [
  "*The hourly rate is determined by dividing the monthly rate by 730 hours (28 days). If your server is online for more than 730 hours in a calendar month, you will only be billed the monthly rate.",
  "*Prices listed above are based on the service being utilized for the period specified.",
  "*All Servers include one IPv4 Address. Additional IPs are available for $2.19/month ($0.003/hour)",
  "*Unlimited inbound bandwidth. If free outbound bandwidth is exceeded, each additional GB is $0.02",
  "*Optional Daily Backups are available for 20% of the server price. Minimum $1.00/month.",
];

export const GPU_TABLE_FOOTER_CONSTANTS = {
  btnText: "Get Your GPU Server",
  text1: (
    <>
      Have specific requirements?{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        target="_blank"
        style={{textDecoration: "underline", color: "#1E87F0", fontWeight: 700}}
      >
        Contact our team
      </Link>{" "}
      for custom builds or enterprise pricing.
    </>
  ),
};
